<template>
    <BaseModal :id="'static-select-date-range'" :title="title" :size="'lg'" :message="message">
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb" />
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="getAssociateQCHistoryReport()">
                <div class="col-md-12 mb-5">
                    <div class="formdynamic_item col-md-6 py-o">
                        <div class="formdynamic__item__field">
                            <label class="modal-label input-date-template" v-html="`Date Range: <b style='color:red;'>*</b>`" />
                            <date-range-picker class="d-block" ref="picker" v-model="form_data.date_range" cancelLabel="Clear">
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ date(picker.startDate) }} - {{ date(picker.endDate) }}
                                </template>

                                <div slot="footer" slot-scope="data" class="slot p-2">
                                    <span class="d-inline-block" style="margin-left: 2px; font-size: 13px; min-width: 7.5rem;">
                                        {{ data.rangeText }}
                                    </span>
                                    <span style="margin-left: auto">
                                        <a @click="clearRangeDate(data)" class="modal__buttons__item cancel">Cancel</a>
                                    </span>
                                    <span style="margin-left: auto">
                                        <a @click="data.clickApply" v-if="!data.in_selection" class="modal__buttons__item" style="width: 4.5rem">Apply</a>
                                    </span>
                                </div>
                            </date-range-picker>
                        </div>
                    </div>
                </div>
                <CentralLiteButtons :save_text="'Generate Report'"/>
            </form>
        </template>
    </BaseModal>
</template>

 
 
<script>
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'
import DateRangePicker from 'vue2-daterange-picker'
import CentralLiteButtons   from    '@/components/CentralLiteButtons'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'


export default {

    name: 'SelectDateRange',
    props: [
        'title',
        'breadcrumb',
    ],

    components: {
        Breadcrumb,
        BaseModal,
        DateRangePicker,
        CentralLiteButtons,
    },

    data() {
        return {
            form_data: { date_range: { startDate: "", endDate: "" }, },
            message: `Please choose the specific start and end dates for the report's filtering criteria.`
        }
    },

    methods: {
        clearRangeDate(data) {
            data.clickCancel()
            this.form_data.date_range = { startDate: null, endDate: null }
        },

        date(val) {
            return val ? moment(val).format("MM/D/YYYY") : "";
        },

        getAssociateQCHistoryReport()
        {
            if(this.form_data.date_range && this.form_data.date_range.startDate && this.form_data.date_range.endDate)
            {
                this.$emit('getAssociateQCHistoryReport', this.form_data)
            }
            else
            {
                this.notyfMesg('Date Range is required', 'error')
            }
        }

        

    },

    mounted() {

    },

}
</script>
